import React from "react";
import { LandingPage } from "../pages/LandingPage";

const PublicRoutes = [
  {
    path: "/",
    component: LandingPage,
  },
  {
    path: "/landing",
    component: LandingPage,
  },
  {
    path: "/public",
    component: () => <div>Public Page</div>,
  },
];

export default PublicRoutes;
